export default __webpack_public_path__ + "static/media/10.63f7e921.svg";